import {clinicPatientsStateUniqueIdentifier} from './dashboard-clinic-patients.model';
import {
  ClinicPatientsAppliedFilters,
  ClinicPatientsSortRule,
  PayloadLoadPatientAccountsSuccess,
} from '../../symbols/dashboard-clinic-patients-manage-list.symbols';
import {SharedPatientData} from '../../symbols/dashboard-clinic-patients.symbols';
import {UnknownError} from '../../../shared/symbols';
import {User} from '../../../auth/symbols';

export class LoadPatientAccountsBySort {
  static readonly type = `${clinicPatientsStateUniqueIdentifier} ${LoadPatientAccountsBySort.name}`;
  constructor(public sortingRule: ClinicPatientsSortRule) {}
}

export class LoadPatientAccountsByName {
  static readonly type = `${clinicPatientsStateUniqueIdentifier} ${LoadPatientAccountsByName.name}`;
  constructor(public searchString: string) {}
}

export class LoadPatientAccountsByPage {
  static readonly type = `${clinicPatientsStateUniqueIdentifier} ${LoadPatientAccountsByPage.name}`;
  constructor(public page: number) {}
}

export class LoadPatientAccountsByFilters {
  static readonly type = `${clinicPatientsStateUniqueIdentifier} ${LoadPatientAccountsByFilters.name}`;
  constructor(public filters: ClinicPatientsAppliedFilters) {}
}

export class LoadPatientAccountsSuccess {
  static readonly type = `${clinicPatientsStateUniqueIdentifier} ${LoadPatientAccountsSuccess.name}`;
  constructor(public payload: PayloadLoadPatientAccountsSuccess) {}
}

export class LoadPatientAccountsFail {
  static readonly type = `${clinicPatientsStateUniqueIdentifier} ${LoadPatientAccountsFail.name}`;
  constructor(public error: UnknownError) {}
}

export class RemovePatientFromClinic {
  static readonly type = `${clinicPatientsStateUniqueIdentifier} ${RemovePatientFromClinic.name}`;
  constructor(public patientId: User[`uid`]) {}
}

export class RemovePatientFromClinicSuccess {
  static readonly type = `${clinicPatientsStateUniqueIdentifier} ${RemovePatientFromClinicSuccess.name}`;
  constructor(public patientId: User[`uid`]) {}
}

export class RemovePatientFromClinicFail {
  static readonly type = `${clinicPatientsStateUniqueIdentifier} ${RemovePatientFromClinicFail.name}`;
  constructor(public patientId: User[`uid`], public error: UnknownError) {}
}

export class GrantAccessForPatient {
  static readonly type = `${clinicPatientsStateUniqueIdentifier} ${GrantAccessForPatient.name}`;
  constructor(public patientId: User[`uid`], public patientData: SharedPatientData) {}
}

export class GrantAccessForPatientSuccess {
  static readonly type = `${clinicPatientsStateUniqueIdentifier} ${GrantAccessForPatientSuccess.name}`;
  constructor(public patientId: User[`uid`], public patientData: SharedPatientData) {}
}

export class GrantAccessForPatientFail {
  static readonly type = `${clinicPatientsStateUniqueIdentifier} ${GrantAccessForPatientFail.name}`;
  constructor(public patientId: User[`uid`], public error: UnknownError) {}
}

export class ResetGrantAccessForPatientIndicators {
  static readonly type = `${clinicPatientsStateUniqueIdentifier} ${ResetGrantAccessForPatientIndicators.name}`;
}


